import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useNavigate } from '@/hooks/use-navigate';
import { buildSearchAfterOrdinationToggle, getInitialOrdinationOpen } from '@/lib/plp-panel-url-state';

export {
    applySortAndCloseOrdinationPanel,
    getInitialOrdinationOpen,
    getSearchWithoutOrdinationParam,
    ORDINATION_CLOSED,
    ORDINATION_OPEN,
    ORDINATION_QUERY_PARAM,
} from '@/lib/plp-panel-url-state';

export function useOrdinationPanelState(initialOrdinationOpen?: boolean) {
    const location = useLocation();
    const navigate = useNavigate();
    const [ordinationOpen, setOrdinationOpen] = useState(Boolean(initialOrdinationOpen));

    useEffect(() => {
        const next = getInitialOrdinationOpen(new URLSearchParams(location.search));
        setOrdinationOpen(next);
    }, [location.search]);

    const toggleOrdinationOpen = useCallback(() => {
        const nextOpen = !ordinationOpen;
        setOrdinationOpen(nextOpen);
        void navigate(
            {
                pathname: location.pathname,
                search: buildSearchAfterOrdinationToggle(location.search, nextOpen),
            },
            { replace: true, preventScrollReset: true }
        );
    }, [ordinationOpen, location.pathname, location.search, navigate]);

    const handleOrdinationOpenChange = useCallback(
        (nextOpen: boolean) => {
            if (nextOpen !== ordinationOpen) {
                toggleOrdinationOpen();
            }
        },
        [ordinationOpen, toggleOrdinationOpen]
    );

    return [ordinationOpen, toggleOrdinationOpen, handleOrdinationOpenChange] as const;
}
